import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Observable } from 'rxjs';

import { ExternalLink } from '../../interfaces/external-link.interface';

@Component({
  selector: 'fin-external-link',
  templateUrl: './external-link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExternalLinkComponent {
  @Input()
  link$: Observable<ExternalLink>;

  constructor() {
    /* noop */
  }
}
